import { UserMessageBubble } from '@/modules/common/Chat/ChatMessage/UserMessageBubble';
import { MessageRole } from '@/types/schema';

import { AskDocumentQuestion_MessageFragment } from '../graphql/AskDocumentQuestion.generated';
import { DocumentChatAssistantMessageBubble } from './DocumentChatAssistantMessageBubble/DocumentChatAssistantMessageBubble';

export interface DocumentChatMessageProps {
  message: AskDocumentQuestion_MessageFragment;
  enableCopyCitationPopover?: boolean;
  isStreaming?: boolean;
}

export function DocumentChatMessage({
  message,
  enableCopyCitationPopover = false,
  isStreaming = false,
}: DocumentChatMessageProps) {
  const isUser = message.role === MessageRole.User;

  return isUser ? (
    <UserMessageBubble content={message.content} />
  ) : (
    <DocumentChatAssistantMessageBubble
      message={message}
      enableCopyCitationPopover={enableCopyCitationPopover}
      isStreaming={isStreaming}
    />
  );
}
